import { render } from "./RepliCePortal.vue?vue&type=template&id=361b31ae"
import script from "./RepliCePortal.vue?vue&type=script&lang=js"
export * from "./RepliCePortal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__